import { useOrgTenant } from 'src/hooks/auth/use-org-tenant';

import { useFeatures } from 'src/sections/billing/usage/hooks/use-features';

import { TenantType } from 'src/types/enums';
import { FeatureType } from 'src/types/subscription.types';

/**
 * Call lists ride on Task Management, for recruiter and client agencies (JT1-1827). Check this before
 * querying them: the API answers 402 without the feature, which opens the upgrade dialog.
 */
export function useCallListsEnabled(): boolean {
  const tenant = useOrgTenant();
  const { canAccess } = useFeatures();
  return canAccess(FeatureType.TASK_MANAGEMENT_ENABLED) && (tenant === TenantType.Recruiter || tenant === TenantType.Client);
}
